<template>
    <div class="box-white-wrapper cashback">
        <vs-table search :data="cashbackData" pagination max-items="10" v-if="cashbackData.length > 1">
            <template slot="thead">
                <vs-th sort-key="amount">Monto</vs-th>
                <vs-th sort-key="month">Fecha </vs-th>
                <vs-th sort-key="statusname"> Estado </vs-th>
            </template>
            <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data" >
                    <vs-td :data="data[indextr].amount">
                        ${{data[indextr].amount}}
                    </vs-td>
                    <vs-td :data="data[indextr].month">
                        {{ data[indextr].monthName +", "+ data[indextr].year }}
                    </vs-td>
                    <vs-td :data="data[indextr].statusname">
                        {{data[indextr].statusname}}
                    </vs-td>
                </vs-tr>
            </template>
        </vs-table> 
        <displayInformation  v-if="cashbackData.length < 1" message="Aún no se han registrado movimientos de cashback" :showButton="false"></displayInformation>         
    </div>
</template>
<script>
import {helper} from '@/helpers/utils'
import { Role } from '@/helpers/Role.js'
import { mapState } from 'vuex'
import CashbackDataService from "@/services/CashbackDataService"
import DisplayInformation from '@/components/DisplayInformation.vue'
export default {
  name: "Customer",
  mixins: [helper],
  components:{
    DisplayInformation
  },
  data () {
    return {
      cashbackData: [],
    }
  },
  computed: {
    ...mapState([
      'userInfoData'
    ]),
  },
  created(){
    this.Roles = Role
  },
  mounted (){
    this.retrieveCustomer()
  },
  methods: {
    retrieveCustomer() {
        CashbackDataService.getCashback(this.userInfoData.customer.id)
        .then(response => {
            this.cashbackData = response.data
        })
        .catch(e => {
            console.log(e);
            this.$vs.notify({title:'Error!',text:'Error obteniendo los datos del cliente!',color:'danger',icon:'error_outline'})
         });
    },

  }
}
</script>